import { LanguagesTypes } from '@hydra/types';

function getLanguage (locale: LanguagesTypes): string {
  switch (locale) {
    case 'de':
    case 'es':
    case 'fr':
    case 'nl':
    case 'pt':
      return locale;
    case 'en':
    default:
      return 'en-us';
  }
}

export function getHelpLink (locale: LanguagesTypes, relativeUrl = ''): string {
  const language = getLanguage(locale);

  relativeUrl = relativeUrl.replace(/^\/+/, '');

  if (relativeUrl) {
    relativeUrl = `/${relativeUrl}`;
  }

  return `https://help.woorank.com/hc/${language}${relativeUrl}`;
}

export default getHelpLink;
